import { stopSyncIncrementally } from "@/services/api/orderSync";
import { useRequest } from "ahooks";
import { Button } from "antd";
import React from "react";

interface StopButtonProps {
    supplierShopId: number;

    onStop(): void;
}

const StopButton: React.FC<StopButtonProps> = function (props) {
    const { supplierShopId, onStop } = props;

    const stopSyncIncremental = useRequest(stopSyncIncrementally, { manual: true });

    async function handleStopButtonClick() {
        await stopSyncIncremental.runAsync(supplierShopId);

        onStop();
    }

    return (
        <Button type="link" onClick={handleStopButtonClick} loading={stopSyncIncremental.loading}>
            停止同步
        </Button>
    );
};

export default React.memo(StopButton);
